export const projectCode = 'AFC_PROD';

export const timerInterval = 10 * 1000;

export const provinceMap = [{
        "label": "北京市",
        "value": "北京市"
    },
    {
        "label": "上海市",
        "value": "上海市"
    },
    {
        "label": "天津市",
        "value": "天津市"
    },
    {
        "label": "重庆市",
        "value": "重庆市"
    },
    {
        "label": "黑龙江省",
        "value": "黑龙江省"
    },
    {
        "label": "吉林省",
        "value": "吉林省"
    },
    {
        "label": "辽宁省",
        "value": "辽宁省"
    },
    {
        "label": "内蒙古自治区",
        "value": "内蒙古自治区"
    },
    {
        "label": "河北省",
        "value": "河北省"
    },
    {
        "label": "新疆维吾尔自治区",
        "value": "新疆维吾尔自治区"
    },
    {
        "label": "甘肃省",
        "value": "甘肃省"
    },
    {
        "label": "青海省",
        "value": "青海省"
    },
    {
        "label": "陕西省",
        "value": "陕西省"
    },
    {
        "label": "宁夏回族自治区",
        "value": "宁夏回族自治区"
    },
    {
        "label": "河南省",
        "value": "河南省"
    },
    {
        "label": "山东省",
        "value": "山东省"
    },
    {
        "label": "山西省",
        "value": "山西省"
    },
    {
        "label": "安徽省",
        "value": "安徽省"
    },
    {
        "label": "湖北省",
        "value": "湖北省"
    },
    {
        "label": "湖南省",
        "value": "湖南省"
    },
    {
        "label": "江苏省",
        "value": "江苏省"
    },
    {
        "label": "四川省",
        "value": "四川省"
    },
    {
        "label": "贵州省",
        "value": "贵州省"
    },
    {
        "label": "云南省",
        "value": "云南省"
    },
    {
        "label": "广西壮族自治区",
        "value": "广西壮族自治区"
    },
    {
        "label": "西藏自治区",
        "value": "西藏自治区"
    },
    {
        "label": "浙江省",
        "value": "浙江省"
    },
    {
        "label": "江西省",
        "value": "江西省"
    },
    {
        "label": "广东省",
        "value": "广东省"
    },
    {
        "label": "福建省",
        "value": "福建省"
    },
    {
        "label": "台湾省",
        "value": "台湾省"
    },
    {
        "label": "海南省",
        "value": "海南省"
    },
    {
        "label": "香港特别行政区",
        "value": "香港特别行政区"
    },
    {
        "label": "澳门特别行政区",
        "value": "澳门特别行政区"
    }
]

export const moonOptions = [{
        "label": "1日",
        "value": 1
    },
    {
        "label": "2日",
        "value": 2
    },
    {
        "label": "3日",
        "value": 3
    },
    {
        "label": "4日",
        "value": 4
    },
    {
        "label": "5日",
        "value": 5
    },
    {
        "label": "6日",
        "value": 6
    },
    {
        "label": "7日",
        "value": 7
    },
    {
        "label": "8日",
        "value": 8
    },
    {
        "label": "9日",
        "value": 9
    },
    {
        "label": "10日",
        "value": 10
    },
    {
        "label": "11日",
        "value": 11
    },
    {
        "label": "12日",
        "value": 12
    },
    {
        "label": "13日",
        "value": 13
    },
    {
        "label": "14日",
        "value": 14
    },
    {
        "label": "15日",
        "value": 15
    },
    {
        "label": "16日",
        "value": 16
    },
    {
        "label": "17日",
        "value": 17
    },
    {
        "label": "18日",
        "value": 18
    },
    {
        "label": "19日",
        "value": 19
    },
    {
        "label": "20日",
        "value": 20
    },
    {
        "label": "21日",
        "value": 21
    },
    {
        "label": "22日",
        "value": 22
    },
    {
        "label": "23日",
        "value": 23
    },
    {
        "label": "24日",
        "value": 24
    },
    {
        "label": "25日",
        "value": 25
    },
    {
        "label": "26日",
        "value": 26
    },
    {
        "label": "27日",
        "value": 27
    },
    {
        "label": "28日",
        "value": 28
    },
    {
        "label": "29日",
        "value": 29
    },
    {
        "label": "30日",
        "value": 30
    },
    {
        "label": "31日",
        "value": 31
    }
]

export const weekOptions = [{
        "label": "周一",
        "value": 1
    },
    {
        "label": "周二",
        "value": 2
    },
    {
        "label": "周三",
        "value": 3
    },
    {
        "label": "周四",
        "value": 4
    },
    {
        "label": "周五",
        "value": 5
    },
    {
        "label": "周六",
        "value": 6
    },
    {
        "label": "周日",
        "value": 7
    }
]